/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// helpers
import { formatPhoneNumber } from 'Components/helpers';

const workTypeSettings = [
   { name: 1, text: 'searchWorkTypeFullTime' },
   { name: 2, text: 'searchWorkTypePartTime' },
   { name: 3, text: 'searchWorkTypeRemoteWork' },
   { name: 4, text: 'searchWorkTypeVariableSchedule' },
   { name: 5, text: 'searchWorkTypeFlexibleSchedule' },
   { name: 6, text: 'searchWorkTypeWatchMethod' },
];
import { CandidateComment } from './candidate-comment';
import { CandidateAppliedStore } from './candidate-applied-store';
import { Flex } from '@radix-ui/themes';
const Questionnaire = ({ cvDetails }) => {
   const [candidateAppliedStore] = useState(() => new CandidateAppliedStore());
   const { t } = useTranslation('global');

   const { jobInfo = {}, jobApply = {}, categories = [], userdetail = {} } = cvDetails;

   const getCategoryName = (id) => {
      for (let i = 0; i < categories.length; i++) {
         if (categories[i].id == id) {
            return categories[i].name;
         }
      }
   };

   const getDefaultSubCategoryName = (id) => {
      for (let i = 0; i < jobApply?.subcategories.length; i++) {
         if (jobApply?.subcategories[i].id == id) {
            return jobApply?.subcategories[i].name;
         }
      }
   };

   const getDefaultSubCategoryName2 = (id) => {
      for (let i = 0; i < jobApply?.subcategories_2.length; i++) {
         if (jobApply?.subcategories_2[i].id == id) {
            return jobApply?.subcategories_2[i].name;
         }
      }
   };

   const getDefaultSubCategoryName3 = (id) => {
      for (let i = 0; i < jobApply?.subcategories_3.length; i++) {
         if (jobApply?.subcategories_3[i].id == id) {
            return jobApply?.subcategories_3[i].name;
         }
      }
   };

   const showEmail = (email) => {
      if (!email) {
         return false;
      }

      if (email.includes('@email.grc.ua')) {
         return false;
      }

      return true;
   };

   return (
      <div className="cvDescription">
         <div className="personalInfoSection">
            <div>
               <h1>
                  {jobInfo?.job_title}
                  <span className="ms-2 fs-4 text-muted">
                     ({t('employerInnerAccountdetail.questionnaire')})
                  </span>
               </h1>
               <div className="">
                  <h2>
                     {userdetail?.last_name} {userdetail?.first_name}
                  </h2>
               </div>
               <Flex mb="4">
                  <CandidateComment jobApply={jobApply} store={candidateAppliedStore} />
               </Flex>
               <div className="contactsBox">
                  {jobApply?.contact && (
                     <p>
                        <i className="fa-solid fa-phone" />
                        <a href={`tel:${jobApply?.contact}`}>
                           {formatPhoneNumber(jobApply?.contact)}
                        </a>
                     </p>
                  )}
                  {showEmail(userdetail?.email_address) && (
                     <p>
                        <i className="fa-solid fa-envelope" />
                        <a href={`mailto:${userdetail?.email_address}`}>
                           {userdetail?.email_address}
                        </a>
                     </p>
                  )}
               </div>
               <div className="wishesInfoBox">
                  <p>
                     <i className="fa-solid fa-sitemap" />
                     <span>
                        {t('cvDescription.category')}
                        {': '}
                     </span>
                     {jobInfo?.category && getCategoryName(jobInfo?.category)}
                     {jobInfo?.category_2 && `; ${getCategoryName(jobInfo?.category_2)}`}
                     {jobInfo?.category_3 && `; ${getCategoryName(jobInfo?.category_3)}`}
                  </p>
                  <p>
                     <i className="fa-solid fa-sitemap" />
                     <span>
                        {t('cvDescription.subCategory')}
                        {': '}
                     </span>
                     {jobInfo?.subcategory_id.length > 0
                        ? jobInfo?.subcategory_id
                             .map((i) => {
                                const category = getDefaultSubCategoryName(i);
                                return category;
                             })
                             .join('; ')
                        : t('cvCard.notSpecified')}
                     {jobInfo?.subcategory_id_2?.length > 0 && '; '}
                     {jobInfo?.subcategory_id_2?.length > 0 &&
                        jobInfo?.subcategory_id_2
                           ?.map((i) => {
                              const category = getDefaultSubCategoryName2(i);
                              return category;
                           })
                           .join('; ')}
                     {jobInfo?.subcategory_id_3?.length > 0 && '; '}
                     {jobInfo?.subcategory_id_3?.length > 0 &&
                        jobInfo?.subcategory_id_3
                           ?.map((i) => {
                              const category = getDefaultSubCategoryName3(i);
                              return category;
                           })
                           .join('; ')}
                  </p>
                  <p>
                     <i className="fa-sharp fa-solid fa-location-dot" />
                     <span>
                        {t('cvDescription.relocations')}
                        {': '}
                     </span>
                     {jobInfo?.city.city_name && jobInfo.city.city_name}
                     {jobInfo?.city.country_name && `, ${jobInfo.city.country_name}`}
                  </p>
                  <p>
                     <i className="fa-solid fa-clock" />
                     <span>
                        {t('cvDescription.workType')}
                        {': '}
                     </span>
                     {jobInfo?.work_type &&
                        t(
                           `jobseekerListing.${workTypeSettings.find((i) => i.name === jobInfo.work_type)?.text}`
                        )}
                  </p>
               </div>
            </div>
            <div className="profileImageBox">
               <img
                  alt="profile image"
                  className="profileImage"
                  src="/Images/jobseekerSide/dummy-profile.png"
               />
            </div>
         </div>
      </div>
   );
};

export default Questionnaire;
